import { Injectable, type Type } from '@angular/core';
import { HelpAssistantEntry } from '@aurora/modules/manual';

/**
 * Binds the `tools` assistant chat to the admin layout's help-assistant port. The manifest imports
 * this file, not the folder barrel, and the chat loads with a dynamic import, so neither reaches the
 * initial bundle.
 */
@Injectable()
export class ToolsHelpAssistantEntry extends HelpAssistantEntry {
  loadComponent(): Promise<Type<unknown>> {
    return import('./tools-assistant-chat.component').then((module) => module.ToolsAssistantChat);
  }
}
